import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'groups'

const api = new ApiCore({
  index: false,
  findOne: false,
  create: false,
  update: false,
  remove: false,
  url: url
})

api.list = (pathParams = '') => {
  const pathSegment = pathParams ? `/${pathParams}` : '';
  return axios
    .get(`${apiProvider.BASE_URL}/${url}/list${pathSegment}`)
    .then(handleResponse)
    .catch(handleError);
}

api.assignUser = (payload, pathParams = '') => {
  const pathSegment = pathParams ? `/${pathParams}` : '';
  return axios
    .put(`${apiProvider.BASE_URL}/${url}/users${pathSegment}`, payload)
    .then(handleResponse)
    .catch(handleError);
}

export default api
